<route>
{
  "meta": {
    "requiresAuth": true,
    "customSite": true
  }
}
</route>

<template>
  <div class="site-wrapper">
    <div>
      <a class="revBtn float-right" v-on:click="editAcctInfo()">Edit</a>
      <h1 class="-mb-2">{{ userName }}</h1>
      <div class="mb-4">
        {{ acctUsername }} / {{ userEmail }}
        <a
          class="revBtn"
          v-on:click="verificationRequest()"
          v-if="userEmailNeedsVerification"
          >Verify</a
        >
      </div>
    </div>
    <!--
    <h2>
      Choose a topic that you want to learn more about and subscribe to get
      daily e-mails!
    </h2>
    -->
    <div v-if="chSubscriptions && chSubscriptions.length > 0">
      <div>Current Subscriptions:</div>
      <div v-for="sub in chSubscriptions" :key="sub" class="ml-4">
        <a target="_blank" :href="`https://recap.ai/${sub}`">{{ sub }}</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.revBtn {
  @apply mt-8 px-4 border rounded border-primaryLink;
}
.revBtn:hover {
  @apply bg-primaryLink text-white no-underline cursor-pointer;
}
</style>

<script>
import utils from '@/services/utils';
import store from '@/store';

export default {
  name: 'home',
  layout: 'null',
  store,
  data() {
    return {
      userName: null,
      userEmail: null,
      acctUsername: null,
    };
  },
  methods: {
    editAcctInfo() {
      console.log('Edit Account Info');
      this.$router.push('/m/edit');
    },
    async verificationRequest() {
      utils.setStatusMsg(this, 'E-mail address verification request sent.');
      this.user.sendEmailVerification();
    },
  },
  computed: {
    chSubscriptions() {
      return store.state.chSubscriptions;
    },
    userEmailNeedsVerification() {
      return this.$store.state.user?.isVerified;
    },
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    if (this.user) {
      this.userName = this.user.name;
      this.userEmail = this.user.email;
      this.acctUsername = '';
    } else {
      console.log('not signed in...');
    }
  },
};
</script>
